import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function Title() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const centered = !isDesktop && !isWideDesktop

  return (
    <Column alignCenter={!isWideDesktop} fullWidth>
      <AppearingWrapper centered={!isWideDesktop} kind="expand">
        <SubsectionTitle
          centered={centered}
          paragraph={
            <>
              Emajin Golf provides you with unrivalled opportunities to hear
              from and connect with{!centered ? <br /> : ' '}some of the most
              influential business leaders in Australia.
            </>
          }
          subtitle="Rub shoulders with industry-leading professionals."
          title="Learn from Expert Keynote Speakers"
        />
      </AppearingWrapper>
    </Column>
  )
}

export default Title
